import { render, staticRenderFns } from "./pc-academy-videos.vue?vue&type=template&id=21a2b7ec"
import script from "./pc-academy-videos.vue?vue&type=script&lang=js"
export * from "./pc-academy-videos.vue?vue&type=script&lang=js"
import style0 from "./pc-academy-videos.vue?vue&type=style&index=0&id=21a2b7ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports